(function () {
  'use strict';

  var VIEW_THRESHOLD = 0.5;
  var firedViews = Object.create(null);

  function isEnabled() {
    return window.CLAWLAB_PROMOTION_TRACKING_ENABLED === true;
  }

  function getPromotionRoot(element) {
    return element && element.closest('[data-promotion-context]');
  }

  function getPromotionParams(root) {
    return {
      promotion_id: root.dataset.promotionId || '',
      promotion_name: root.dataset.promotionName || '',
      creative_name: root.dataset.promotionCreativeName || '',
      creative_slot: root.dataset.promotionCreativeSlot || '',
      page_location: window.location.href
    };
  }

  function isConfigured(root) {
    return Boolean(
      root &&
      root.dataset.promotionId &&
      root.dataset.promotionName &&
      root.dataset.promotionCreativeName &&
      root.dataset.promotionCreativeSlot
    );
  }

  function getViewKey(root) {
    var params = getPromotionParams(root);

    return [
      params.promotion_id,
      params.creative_slot
    ].join('|');
  }

  function pushEvent(eventName, params) {
    if (!isEnabled()) return false;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: eventName }, params));

    if (window.Shopify && window.Shopify.designMode) {
      console.log('[Promotion Tracking]', eventName, params);
    }

    return true;
  }

  function isElementVisible(element) {
    var current = element;

    if (!element || !element.isConnected || !element.getClientRects().length) return false;

    while (current && current.nodeType === 1) {
      var style = window.getComputedStyle(current);

      if (
        style.display === 'none' ||
        style.visibility === 'hidden' ||
        parseFloat(style.opacity) === 0 ||
        current.getAttribute('aria-hidden') === 'true'
      ) {
        return false;
      }

      current = current.parentElement;
    }

    return true;
  }

  function getVisibleRatio(element) {
    var rect = element.getBoundingClientRect();
    var viewportWidth = window.innerWidth || document.documentElement.clientWidth;
    var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    var visibleWidth = Math.max(0, Math.min(rect.right, viewportWidth) - Math.max(rect.left, 0));
    var visibleHeight = Math.max(0, Math.min(rect.bottom, viewportHeight) - Math.max(rect.top, 0));
    var area = rect.width * rect.height;

    return area > 0 ? (visibleWidth * visibleHeight) / area : 0;
  }

  function bindPromotionView(root) {
    var key;
    var observer;
    var mutationObserver;
    var isFinished = false;

    if (root.dataset.promotionTrackingBound === 'true' || !isConfigured(root)) return;

    root.dataset.promotionTrackingBound = 'true';
    key = getViewKey(root);

    function cleanup() {
      if (observer) observer.disconnect();
      if (mutationObserver) mutationObserver.disconnect();
      window.removeEventListener('resize', checkView);
      window.removeEventListener('orientationchange', checkView);
      window.removeEventListener('scroll', checkView);
      document.removeEventListener('visibilitychange', checkView);
    }

    function checkView() {
      if (isFinished || !isEnabled()) return;
      if (firedViews[key]) {
        isFinished = true;
        cleanup();
        return;
      }
      if (!isElementVisible(root) || getVisibleRatio(root) < VIEW_THRESHOLD) return;

      firedViews[key] = true;
      isFinished = true;
      pushEvent('view_promotion', getPromotionParams(root));
      cleanup();
    }

    if (firedViews[key]) return;

    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.target === root && entry.intersectionRatio >= VIEW_THRESHOLD) {
            checkView();
          }
        });
      }, { threshold: [0, VIEW_THRESHOLD, 1] });
      observer.observe(root);
    } else {
      window.addEventListener('scroll', checkView, { passive: true });
    }

    if ('MutationObserver' in window) {
      mutationObserver = new MutationObserver(function () {
        checkView();
        window.setTimeout(checkView, 600);
      });
      mutationObserver.observe(root, {
        attributes: true,
        attributeFilter: ['class', 'style', 'aria-hidden']
      });
    }

    window.addEventListener('resize', checkView);
    window.addEventListener('orientationchange', checkView);
    document.addEventListener('visibilitychange', checkView);
    checkView();
  }

  function bindPromotionViews(scope) {
    var rootScope = scope && scope.querySelectorAll ? scope : document;
    var roots = rootScope.querySelectorAll('[data-promotion-context][data-promotion-view="true"]');

    Array.prototype.forEach.call(roots, bindPromotionView);
  }

  function bindPromotionClicks() {
    document.addEventListener('click', function (event) {
      var target = event.target.closest('[data-promotion-click]');
      var root;
      var params;
      var destinationUrl;

      if (!target || !isEnabled()) return;

      root = getPromotionRoot(target);
      if (!isConfigured(root)) return;

      params = getPromotionParams(root);
      params.cta_text = target.dataset.promotionCta || target.textContent.trim().replace(/\s+/g, ' ');

      destinationUrl = target.getAttribute('href') || target.dataset.promotionDestinationUrl;
      if (destinationUrl) params.destination_url = destinationUrl;

      pushEvent('select_promotion', params);
    }, true);
  }

  function init() {
    if (!isEnabled()) return;

    bindPromotionClicks();
    bindPromotionViews(document);

    document.addEventListener('shopify:section:load', function (event) {
      bindPromotionViews(event.target);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
